import { LanguageCode } from '@headless-workspace/config';

type PlayerOptionsProps = {
    websiteId: string;
    widgets: {
        type: string;
        nodeId: string;
        productId: string;
        device: string;
        icon: string;
        chevron: null;
        direction: string;
        closedStateMainText: string;
        closedStateSecondaryText: string;
        closedStateDisplayChevron: boolean;
        scale: number;
        animation: string;
        placement: {
            top: string;
            right: string;
        };
        locale: LanguageCode;
    }[];
    theme: {
        fontFamily: string;
        backgroundOutside: string;
        backgroundInside: string;
        iconColor: string;
        openStateTextColor: string;
        closedStateTextColor: string;
        closedStateMainTextSize: string;
        closedStateMainTextWeight: number;
        closedStateSecondaryTextSize: string;
        closedStateSecondaryTextWeight: number;
        borderColor: string;
        borderWidth: string;
        starsColor: string;
        playerShadow: boolean;
    };
};

const AUDIO_PLAYER_THEME = {
    fontFamily: 'var(--avant-garde-gothic), Arial, sans-serif',
    backgroundOutside: 'var(--background-inverse)',
    backgroundInside: 'var(--background-inverse)',
    iconColor: 'var(--text-primary-inverse)',
    openStateTextColor: 'var(--text-primary)',
    closedStateTextColor: 'var(--text-primary)',
    closedStateMainTextSize: '14px',
    closedStateMainTextWeight: 700,
    closedStateSecondaryTextSize: '14px',
    closedStateSecondaryTextWeight: 500,
    borderColor: 'var(--border-selected)',
    borderWidth: '0px',
    starsColor: '#FECC4B',
    playerShadow: false,
};

export const PlayerOptions = (
    language: LanguageCode,
    audioContainerId: string,
    masterProductId: string,
    mainText: string,
    secondaryText: string,
    websiteId: string,
): PlayerOptionsProps => {
    return {
        websiteId,
        widgets: [
            {
                type: 'standalone',
                nodeId: audioContainerId,
                productId: masterProductId,
                device: 'all',
                icon: 'icon-play',
                chevron: null,
                direction: 'normal',
                closedStateMainText: mainText,
                closedStateSecondaryText: secondaryText,
                closedStateDisplayChevron: false,
                scale: 1,
                animation: 'null',
                placement: {
                    top: '0px',
                    right: '0px',
                },
                locale: language,
            },
        ],
        theme: AUDIO_PLAYER_THEME,
    };
};
